import type { ReactNode } from 'react';
import type { IconComponent } from '../icons';
import './EmptyState.css';

export interface EmptyStateProps {
  icon?: IconComponent;
  title: ReactNode;
  body?: ReactNode;
  /** Buttons/links; the first one may be the screen's primary. */
  actions?: ReactNode;
  /** Extra content under the actions (tiles, QR card). */
  children?: ReactNode;
  /** Compact variant for panels and cards. */
  compact?: boolean;
  className?: string;
}

/** Friendly empty state: an icon, a sentence, at most two actions. */
export function EmptyState({ icon: Icon, title, body, actions, children, compact, className }: EmptyStateProps) {
  return (
    <div className={['empty-state', compact ? 'empty-state-compact' : '', className ?? ''].filter(Boolean).join(' ')}>
      {Icon ? (
        <div className="empty-state-icon">
          <Icon size={compact ? 24 : 32} />
        </div>
      ) : null}
      <h2 className="empty-state-title">{title}</h2>
      {body ? <p className="empty-state-body">{body}</p> : null}
      {actions ? <div className="empty-state-actions">{actions}</div> : null}
      {children ? <div className="empty-state-extra">{children}</div> : null}
    </div>
  );
}
